export const TYPE_LINE = 'line';
export const TYPE_LINE_TWO_Y = 'line2Y';
export const TYPE_BAR = 'bar';
export const TYPE_AREA = 'area';
